import { motion } from 'framer-motion';
import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

export const ResourceDetailVoteWrapper = styled.div`
  width: 100%;
  min-height: 116px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  padding: 5px 20px;

  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: rgba(244, 243, 243, 0.7);
  box-shadow: 0 6px 24px 0 rgba(65, 81, 100, 0.2);
  backdrop-filter: blur(3px);

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

export const ResourceDetailVoteContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;

    gap: 10px;
  }
`;

export const ResourceDetailVoteIconContainer = styled.div`
  width: 45px;
  height: 45px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  border: 1px solid var(--color-primary);
`;

export const ResourceDetailVoteIcon = styled.img`
  width: 45px;
  height: 45px;

  object-fit: cover;
`;

export const ResourceDetailVoteText = styled(motion.span).attrs({
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
})`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    text-align: center;
  }
`;

interface ResourceDetailVoteButtonProps {
  disabled: boolean;
}

export const ResourceDetailVoteButton = styled(motion.button)<ResourceDetailVoteButtonProps>`
  min-width: max-content;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  background: ${({ theme }) => (theme.isVoted ? '#FBAFA1' : 'var(--color-data-people-background)')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 16px 48px 16px 40px;

  & .spinner-icon {
    ${infiniteRotationAnimation('1s', 'ease')}
  }

  overflow: hidden;
`;

export const ResourceDetailVoteButtonContainer = styled(motion.div).attrs({
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
})`
  display: flex;
  align-items: center;
  gap: 10px;

  overflow: hidden;
`;

export const ResourceDetailVoteButtonLabel = styled(motion.span)`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  text-wrap: nowrap;

  color: var(--color-text);
`;

export const ResourceDetailVoteButtonCheckContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: #f58257;
`;
